import { Routes } from '@angular/router';

import { LicenceSchoolComponent } from './licence-school.component';
import { LicenceSchoolDetailComponent } from './licence-school-detail.component';
import { LicenceSchoolPopupComponent } from './licence-school-dialog.component';
import { LicenceSchoolDeletePopupComponent } from './licence-school-delete-dialog.component';
import {UserRouteAccessService} from '../../shared/auth/user-route-access-service';

export const licenceSchoolRoute: Routes = [
  {
    path: 'referentiel-licences',
    component: LicenceSchoolComponent,
    data: {
        authorities: ['ROLE_ADMIN'],
        pageTitle: 'tmmsaisineApp.licenceSchool.home.title'
    },
      canActivate: [UserRouteAccessService]
  }, {
    path: 'referentiel-licences/:id',
    component: LicenceSchoolDetailComponent,
    data: {
        authorities: ['ROLE_ADMIN'],
        pageTitle: 'tmmsaisineApp.licenceSchool.home.title'
    },
        canActivate: [UserRouteAccessService]
    }
];

export const licenceSchoolPopupRoute: Routes = [
  {
    path: 'referentiel-licences-nouveau',
    component: LicenceSchoolPopupComponent,
    data: {
        authorities: ['ROLE_STUDENT'],
        pageTitle: 'tmmsaisineApp.licenceSchool.home.title'
    },
    outlet: 'popup'
  },
  {
    path: 'referentiel-licences/:id/edition',
    component: LicenceSchoolPopupComponent,
    data: {
        authorities: ['ROLE_STUDENT'],
        pageTitle: 'tmmsaisineApp.licenceSchool.home.title'
    },
    outlet: 'popup'
  },
  {
    path: 'referentiel-licences/:id/suppression',
    component: LicenceSchoolDeletePopupComponent,
    data: {
        authorities: ['ROLE_STUDENT'],
        pageTitle: 'tmmsaisineApp.licenceSchool.home.title'
    },
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/licence-school/licence-school.route.ts